import { render, staticRenderFns } from "./NsAvatar.vue?vue&type=template&id=2903128a&"
import script from "./NsAvatar.vue?vue&type=script&lang=js&"
export * from "./NsAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports